import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { IEGColorTransform } from '@tencent/slide-sdk-model';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import {
    ICTSchemeColor,
    ICTSRgbColor,
    IEGColorChoice, IEGColorChoiceDelta,
    STSchemeColorVal,
} from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import {
    ColorTransformConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/color/color-transform-converter';

/**
 * 颜色转换
 */
export class ColorConverter {
    public static convertPartialDataFromSdkToUi(sdkData: DeepReadonly<DeepPartial<IEGColorChoice>>): TDColor {
        let egColorTransform: DeepReadonly<DeepPartial<IEGColorTransform[]>> = [];
        const { schemeClr, srgbClr } = sdkData;

        let uiData: TDColor;
        // 带主题
        if (schemeClr?.val) {
            uiData = new TDColor({
                rgbaStr: srgbClr?.val,
                themeKey: schemeClr.val,
            });

            if (schemeClr?.egColorTransform) {
                egColorTransform = schemeClr.egColorTransform;
            }
        } else { // 不带主题
            uiData = new TDColor({
                rgbaStr: srgbClr?.val,
            });
            if (srgbClr?.egColorTransform) {
                egColorTransform = srgbClr.egColorTransform;
            }
        }

        // 统一转换transform
        if (uiData && egColorTransform?.length) {
            ColorTransformConverter.convertPartialDataFromSdkToUi(egColorTransform, uiData);
        }

        return uiData;
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<ITDColor>>,
        sdkData: DeepPartial<IEGColorChoiceDelta>,
    ) {
        const egColorTransform: IEGColorTransform[] = [];
        ColorTransformConverter.convertPartialDataFromUiToSdk(uiData, egColorTransform);
        if (Number.isSafeInteger(uiData?.colorValue)) {
            const schemeClr: ICTSchemeColor = {};
            schemeClr.val = uiData.colorValue as STSchemeColorVal;
            schemeClr.egColorTransform = egColorTransform;
            sdkData.schemeClr = schemeClr;
            sdkData.srgbClr = null;
        } else if (uiData?.colorValue) {
            const srgbClr: ICTSRgbColor = {};
            srgbClr.val = uiData.colorValue as string;
            srgbClr.egColorTransform = egColorTransform;
            sdkData.srgbClr = srgbClr;
            sdkData.schemeClr = null;
        }
    }
}
